import IMG from 'assets/images/lebensartakademie/01_selbstliebe_fuer_gluecksrebellinnen.png'
import { Button, Col, Container, Row, Section } from 'atoms'
import Image from 'next/image'
import { ContactCard } from 'organisms'
import { FC } from 'react'
import { HiChevronDoubleRight } from 'react-icons/hi'

const URL = `https://elopage.com/s/lebensart-akademie/selbstliebe-fuer-gluecksrebellinnen`

const LASelbstliebeFuerGluecksrebellinnen: FC<unknown> = () => (
  <>
    <Section background="rose">
      <Container>
        <h1>
          Selbstliebe für Glücksrebellinnen
        </h1>
        <p className="d-none d-sm-block text-md-center">
          LebensArt Akademie
        </p>
      </Container>
    </Section>
    <Section>
      <Container>
        <Row className='flex-row-reverse align-items-start'>
          <Col xs={12} sm={4}>
            <Button
              rel="noreferrer"
              target="_blank"
              href={URL}
              theme='green'
              size='large'
              type="link"
              block
            >
              Online-Kurs&nbsp;<HiChevronDoubleRight />
            </Button>
            <br/>
            <Image
              src={IMG}
              alt="Selbstliebe für Glücksrebellinnen"
              objectFit="cover"
              placeholder="blur"
              className="image"
            />
          </Col>
          <Col xs={12} sm={8}>
            <p>
              <strong>
                {`Herzlich willkommen, schön, dass du hier bist.`}
              </strong>
            </p>
            <p>
              {`Ich begrüße dich herzlich zum Kurs "Selbstliebe für Glücksrebellinnen" in meiner Online-Akademie LebensArt. Du hast eine Entscheidung getroffen. Du möchtest dein Leben in deine Hand nehmen und nach deinem Maß gestalten.`}
            </p>
            <p>
              {`Ich bin Cordelia Schmidt und ich arbeite als Coach und systemische Therapeutin seit nunmehr über sieben Jahren mit Frauen zusammen, die ihr Leben aktiv gestalten möchten, um zufrieden und in Balance zu leben.`}
            </p>
            <p>
              {`Mit dem Kursangebot kannst du bequem von deinem Wohlfühlort aus und in deinem individuellem Tempo auf deine Lebensthemen schauen. Und wenn du möchtest, auch Veränderung wagen.`}
            </p>
            <p className="text-center">
              {`Die Mutigen beschenkt das Leben.`}
              <br/>
              {`Ich nehme dich mit.`}
              <br/>
              {`Schritt für Schritt.`}
              <br/>
              {`Du bist nicht allein.`}
              <br/>
            </p>
            <p>
              {`Viele andere Frauen stehen vor ähnliche Herausforderungen. Diesen Weg gehen wir gemeinsam.`}
            </p>

            <hr/>

            <h3>
              {`Wie ist der Kurs aufgebaut?`}
            </h3>
            <p>
              {`Der Kurs besteht aus mehreren Modulen, die aufeinander aufgebaut sind. So kannst du dich langsam in deinem Tempo in deine Themen einarbeiten. Kleine Grafiken unterstützen dich auf deiner Reise. Ganz wichtig: Du kannst das neu Gelernte gleich anwenden.  Dazu bekommst du viele maßgeschneiderte Übungen von mir an die Hand. Und wenn es auch einmal nicht gleich so klappt, wie du dir das wünschst, findest du hier immer die richtigen Impulse.`}
            </p>

            <hr/>
            <Button
              rel="noreferrer"
              target="_blank"
              href={URL}
              theme='green'
              type="link"
              block
            >
              Hier geht es zum Online-Kurs&nbsp;<HiChevronDoubleRight />
            </Button>
          </Col>
        </Row>
      </Container>
    </Section>
    <Section background="vintage">
      <Container>
        <ContactCard />
      </Container>
    </Section>
  </>
)

export default LASelbstliebeFuerGluecksrebellinnen
